const initialState = {
  datos: {},
  rankingData: {
    loadingRanking: false,
    error: null,
    data: {},
    status: null
  },
  questionData: {
    loadingQuestion: false,
    error: null,
    data: {},
    status: null
  },
  filters: {
    loadingFilter: false,
    error: null,
    data: {},
    status: null
  },
  loading: true,
  error: null,
  status: null
};

export default initialState;



// WEBPACK FOOTER //
// ./source/client/reducers/detail_truck/initialState.js